import { FormGroup, Stack, Typography } from '@mui/material';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceSuggestionType } from '@retail/products/types';
import { PriceTypeOption } from './PriceTypeOption';

interface Props {
  priceSuggestionTypes: PriceSuggestionType[];
  checkedPriceTypes: PriceSuggestionType[];
  checkPriceType: (priceType: PriceSuggestionType) => void;
  getPriceTypeValue: (value: PriceSuggestionType) => string;
}

export function PriceTypesSelection({
  priceSuggestionTypes,
  checkedPriceTypes,
  checkPriceType,
  getPriceTypeValue,
}: Props) {
  const t = usePriceSuggestionTFunction();

  const priceTypeIsPriortitized = (priceType: PriceSuggestionType) =>
    checkedPriceTypes.includes(priceType);

  return (
    <FormGroup sx={{ gap: 1 }}>
      {(priceSuggestionTypes.includes('FINFO_BASE') ||
        priceSuggestionTypes.includes('FINFO_RECOMMENDED')) && (
        <Stack alignContent="flex-start">
          <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
            {t('priceSuggestion.finfoPriceSuggestion')}
          </Typography>

          <Stack>
            {priceSuggestionTypes.includes('FINFO_BASE') && (
              <PriceTypeOption
                priceType="FINFO_BASE"
                isAdded={priceTypeIsPriortitized('FINFO_BASE')}
                checkPriceType={checkPriceType}
                getPriceTypeValue={getPriceTypeValue}
              />
            )}
            {priceSuggestionTypes.includes('FINFO_RECOMMENDED') && (
              <PriceTypeOption
                priceType="FINFO_RECOMMENDED"
                isAdded={priceTypeIsPriortitized('FINFO_RECOMMENDED')}
                checkPriceType={checkPriceType}
                getPriceTypeValue={getPriceTypeValue}
              />
            )}
          </Stack>
        </Stack>
      )}
      {(priceSuggestionTypes.includes('MG_AGGRESSIVE') ||
        priceSuggestionTypes.includes('MG_CONSERVATIVE') ||
        priceSuggestionTypes.includes('MG_MODERATE')) && (
        <Stack alignContent="flex-start">
          <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
            {t('priceSuggestion.mgSuggestedPrice')}
          </Typography>

          <Stack>
            <PriceTypeOption
              priceType="MG_MODERATE"
              isAdded={priceTypeIsPriortitized('MG_MODERATE')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
            <PriceTypeOption
              priceType="MG_CONSERVATIVE"
              isAdded={priceTypeIsPriortitized('MG_CONSERVATIVE')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
            <PriceTypeOption
              priceType="MG_AGGRESSIVE"
              isAdded={priceTypeIsPriortitized('MG_AGGRESSIVE')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
          </Stack>
        </Stack>
      )}

      {priceSuggestionTypes.includes('LOCAL') && (
        <Stack alignContent="flex-start">
          <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
            {t('priceSuggestion.local')}
          </Typography>

          <Stack>
            <PriceTypeOption
              priceType="LOCAL"
              isAdded={priceTypeIsPriortitized('LOCAL')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
          </Stack>
        </Stack>
      )}
      {priceSuggestionTypes.includes('BRAND') && (
        <Stack alignContent="flex-start">
          <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
            {t('priceSuggestion.global')}
          </Typography>

          <Stack>
            <PriceTypeOption
              priceType="BRAND"
              isAdded={priceTypeIsPriortitized('BRAND')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
          </Stack>
        </Stack>
      )}
      {priceSuggestionTypes.includes('MG_VVS') && (
        <Stack alignContent="flex-start">
          <Typography variant="subtitle2" sx={{ textDecoration: 'underline' }}>
            {t('priceSuggestion.vvsNorway')}
          </Typography>

          <Stack>
            <PriceTypeOption
              priceType="MG_VVS"
              isAdded={priceTypeIsPriortitized('MG_VVS')}
              checkPriceType={checkPriceType}
              getPriceTypeValue={getPriceTypeValue}
            />
          </Stack>
        </Stack>
      )}
    </FormGroup>
  );
}
